// ============================================================
// GoAffPro Affiliate Integration Utility
// ============================================================
// The GoAffPro loader script (in public/index.html) automatically
// tracks visitors arriving via ?a_aid=XXXX affiliate links.
//
// This file just fires the conversion event after a successful order.
// No credentials or IDs needed here.
// ============================================================

/**
 * Fires a GoAffPro conversion event after a successful order.
 * The loader.js script (in index.html) automatically picks up the
 * affiliate cookie set when the visitor arrived via ?a_aid= link.
 *
 * @param {Object} orderData
 * @param {string|number} orderData.orderId   - Your internal order ID
 * @param {string|number} orderData.total     - Final amount paid (after discount)
 * @param {string}        [orderData.coupon]  - Promo/discount code used (if any)
 * @param {string}        [orderData.referrer] - Referral code from ?ref= parameter
 */
export const trackGoAffProConversion = (orderData) => {
  try {
    const { orderId, total, coupon, referrer } = orderData;

    if (typeof window.goaffproTrackConversion !== "undefined") {
      window.goaffpro_order = {
        number: String(orderId),
        total: parseFloat(total).toFixed(2),
        discount_code: coupon || "",
      };
      
      // Add referrer if provided
      if (referrer) {
        window.goaffpro_order.referrer = referrer;
      }
      
      window.goaffproTrackConversion(window.goaffpro_order);
      console.log("[GoAffPro] Conversion tracked:", orderId, "with referrer:", referrer || "none");
    } else {
      console.warn("[GoAffPro] Loader script not ready yet.");
    }
  } catch (err) {
    console.error("[GoAffPro] Error during conversion tracking:", err);
  }
};
